import { useState } from "react";
import { useNavigate, useParams } from "react-router";
import {
  useEmployeePIPUpdateMutation,
  useGetPIPByIdQuery,
} from "../../../../api/employeeApi";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
// import ApproveModal from "../../Modals/ApproveModal";
import { FormProvider, useForm } from "react-hook-form";
import {
  FormTemplate,
  FormTextArea,
} from "../../../Components/Forms/InputTemplate";
import { getStatusText } from "../../Finance/CostCenter/Class";
import { ActionButtons } from "../../../../global/components/Buttons/buttons";
import toast from "react-hot-toast";
export const ViewEmployeePIP = () => {
  const { id, referenceId } = useParams();
  const { data: pip } = useGetPIPByIdQuery(id);
  const [onPIP, { isLoading }] = useEmployeePIPUpdateMutation();
  const navigation = useNavigate();
  const formMethods = useForm({
    mode: "all",
  });
  const {
    handleSubmit,
    formState: { isValid },
  } = formMethods;
  const onSubmit = async (data) => {
    try {
      const response = await onPIP({
        id: pip?.responseObject?.id || 0,
        appraiseeId: pip.responseObject.appraiseeId,
        appraiseeComment: data.appraiseeComment || "",
        referenceId: referenceId,
        kraId: parseInt(pip?.responseObject?.kraId),
        pipType: pip.responseObject.pipType,
        pipObjective: pip.responseObject.pipObjective,
        expectedImprovement: pip.responseObject.expectedImprovement,
        developmentPlan: pip.responseObject.developmentPlan,
        targetImprovementPercent: pip.responseObject.targetImprovementPercent,
        categoryId: pip.responseObject.categoryId,
        supportTypeIds: [parseInt(pip.responseObject.supportTypeIds)],
        trainingMode: pip.responseObject.trainingMode,
        engagementHours: pip.responseObject.engagementHours,
      }).unwrap();
      if (response?.successful) {
        navigation("/dashboard/employee/employee-pip");
        toast.success(response.statusMessage);
      }
    } catch (error) {
      toast.error(error?.data?.statusMessage);
    }
  };

  return (
    <PageLayout
      title={"MY PERFORMANCE IMPROVEMENT PLAN"}
      hasBack={true}
      backURL={"/dashboard/employee/employee-pip"}
    >
      <div className={DashboardStyle.app_view_controls}></div>
      <div>
        <div className={DashboardStyle.view_app_components}>
          <FormProvider {...formMethods}>
            <FormTemplate
              handleSubmit={handleSubmit(onSubmit)}
              className={DashboardStyle.view_app_components}
            >
              <section
                style={{
                  backgroundColor: "#F8FBF8",
                  border: "1px solid #D9E9DA",
                  borderRadius: "8px",
                }}
                className={DashboardStyle.form_section}
              >
                <h4 className={DashboardStyle.form_section_title}>
                  Process <br /> Information
                </h4>
                <div className={DashboardStyle.labels_group}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(32.3%, 1fr))",
                      gap: "10px",
                    }}
                  >
                    <div>
                      <p>PIP Objective:</p>
                      <h4>{pip?.responseObject?.pipObjective || "N/A"}</h4>
                    </div>
                    <div>
                      <p>Approval Status:</p>
                      <h4>
                        {typeof pip?.responseObject?.approvalStatus === "number"
                          ? getStatusText(pip?.responseObject?.approvalStatus)
                          : pip?.responseObject?.approvalStatus || "N/A"}
                      </h4>
                    </div>
                    <div>
                      <p>Expected Improvement:</p>
                      <h4>
                        {pip?.responseObject?.expectedImprovement || "N/A"}
                      </h4>
                    </div>
                    <div>
                      <p>Development Plan:</p>
                      <h4>{pip?.responseObject?.developmentPlan || "N/A"}</h4>
                    </div>
                    <div>
                      <p>Reference Id:</p>
                      <h4>{pip?.responseObject?.referenceId || "N/A"}</h4>
                    </div>
                    <div>
                      <p>PIP Type:</p>
                      <h4>
                        {pip?.responseObject?.pipType === 1
                          ? "Training"
                          : "Counselling"}
                      </h4>
                    </div>
                    <div>
                      <p>Target Improvement %:</p>
                      <h4>
                        {pip?.responseObject?.targetImprovementPercent || 0}%
                      </h4>
                    </div>
                    <div>
                      <p>Engagement Hours:</p>
                      <h4>{pip?.responseObject?.engagementHours || 0}</h4>
                    </div>
                    <div>
                      <p>Start Date:</p>
                      <h4>
                        {pip?.responseObject?.startDate
                          ? new Date(
                              pip.responseObject.startDate
                            ).toLocaleDateString()
                          : "N/A"}
                      </h4>
                    </div>
                    <div>
                      <p>End Date:</p>
                      <h4>
                        {pip?.responseObject?.endDate
                          ? new Date(
                              pip.responseObject.endDate
                            ).toLocaleDateString()
                          : "N/A"}
                      </h4>
                    </div>
                    <div>
                      <p>Is Approved:</p>
                      <h4>{pip?.responseObject?.isApproved ? "Yes" : "No"}</h4>
                    </div>
                  </div>
                </div>
              </section>
              {pip?.responseObject?.approvalStatus === 0 && (
                <div>
                  <FormTextArea
                    className="h-[200px]"
                    title={"PIP Summary"}
                    camelCase={"appraiseeComment"}
                  />
                  <div
                    style={{ marginTop: "1rem" }}
                    className={DashboardStyle.button_cage}
                  >
                    <ActionButtons
                      isLoading={isLoading}
                      disabled={!isValid}
                      width={"auto"}
                      // onClick={onValidate}
                      type={"submit"}
                      className={DashboardStyle?.button_cage_weight}
                      bg="var(--primary-color)"
                    >
                      Submit
                    </ActionButtons>
                  </div>
                </div>
              )}
            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </PageLayout>
  );
};
